// extracted by mini-css-extract-plugin
export default {"row":"ProductsDashboard_row__JvrHF","col":"ProductsDashboard_col__FriOI","card":"ProductsDashboard_card__ufTkM"};